module.exports = __webpack_public_path__ + "img/debt-assist.af693a54.svg";